import script from "./AntecedentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AntecedentForm.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__